<template>
  <email-login-form :bad-link="false"></email-login-form>
</template>

<script>
window.location.href = "/";
import EmailLoginForm from "../components/EmailLoginForm";
export default {
  name: "LoginView",
  components: {EmailLoginForm}
};
</script>

<style scoped></style>
